import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/predictor';

export default {
    predict: (data: any) => ({ method: 'POST', url: endpoint, data } as AxiosRequestConfig),
};
